export const getServiceRequestsForApproval = (state) =>
  state.serviceRequestsForApproval.results;


